export const CONSORTIA_API = 'consortia';
export const POLICIES_API = 'policies';
export const ROLES_API = 'roles';
export const ROLES_USERS_API = `${ROLES_API}/users`;
